import { ActionReducerMap } from '@ngrx/store';
import { UserDetailsPageState } from '../../../AppState';
import { DocumentsReducer, UserDetailsReducer } from './user-details-inline.reducers';


export const UserDetailsInlineReducerMapper: ActionReducerMap<UserDetailsPageState> = {
    UserDetailsWidgetState: UserDetailsReducer,
    DocumentGroupWidgetState: DocumentsReducer
};
